/* CZ Hero Showcase — Two-Act choreography.
   Akt 1: Statement-Hero (maskierter Text-Reveal beim Laden + dezenter
     Recede-Parallax beim Scrollen, Desktop, scrub).
   Akt 2: Bento-Grid "assembled" maskiert beim Eintreten in den Viewport.

   Ohne Hero: kein GSAP. Das Grid ist der erste Viewport (erste Kachel =
   LCP-Bild) und steht sofort im Endzustand; CSS blendet die Kacheln ohne
   Hero gar nicht erst aus, die Section rendert cz-hub-libs dann nicht.
   Mit Hero: czGSAPReady() (gsap + ScrollTrigger). Kacheln, die schon beim
   ersten Layout in der Reveal-Zone liegen (Mobile immer), stehen ebenfalls
   sofort — nur ein Grid unterhalb der Zone setzt sich beim Hineinscrollen
   animiert zusammen. Kommt GSAP nie, Safety-Reveal nach SHOW_AFTER_MS —
   nichts bleibt je dauerhaft unsichtbar. reduced-motion → sofort sichtbar,
   keine Bewegung, kein Warten auf GSAP. */

(function () {
  var SHOW_AFTER_MS = 1500;
  /* Reveal-Zone: Stage-Oberkante oberhalb 82 % der Viewport-Hoehe (wie bisher) */
  var ZONE_MARGIN = '0px 0px -18% 0px';
  var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function prefersReduce() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function initAll() {
    document.querySelectorAll('.cz-showcase').forEach(initOne);
  }

  /* ── Akt 1: Hero entrance (on load) ── */
  function heroEntrance(section, hero) {
    var img      = hero.querySelector('.czsc-hero__media img');
    var line     = hero.querySelector('.czsc-hero__eyebrow-line');
    var eyebrow  = hero.querySelector('.czsc-hero__eyebrow');
    var headLines = hero.querySelectorAll('.czsc-hero__line-in');
    var text     = hero.querySelector('.czsc-hero__text');
    var cta      = hero.querySelector('.czsc-hero__cta');
    var cue      = hero.querySelector('.czsc-hero__cue');

    var tl = gsap.timeline({
      defaults: { ease: 'expo.out' },
      onComplete: function () {
        section.classList.add('hero-ready');
        var arr = [];
        [img, line, eyebrow, text, cta, cue].forEach(function (e) { if (e) arr.push(e); });
        headLines.forEach(function (e) { arr.push(e); });
        /* nur transform/opacity raeumen — inline object-position (Fokuspunkt) bleibt erhalten */
        if (arr.length) gsap.set(arr, { clearProps: 'transform,opacity' });
      }
    });

    if (img)            tl.fromTo(img, { scale: 1.16 }, { scale: 1.06, duration: 1.7, ease: 'power3.out' }, 0);
    if (line)           tl.fromTo(line, { scaleX: 0 }, { scaleX: 1, duration: 0.9 }, 0.15);
    if (eyebrow)        tl.fromTo(eyebrow, { opacity: 0 }, { opacity: 1, duration: 0.8 }, 0.2);
    if (headLines.length) tl.fromTo(headLines, { yPercent: 112 }, { yPercent: 0, duration: 1.15, stagger: 0.12 }, 0.28);
    if (text)           tl.fromTo(text, { yPercent: 60, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1.0 }, 0.6);
    if (cta)            tl.fromTo(cta, { yPercent: 60, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.9 }, 0.72);
    if (cue)            tl.fromTo(cue, { opacity: 0 }, { opacity: 1, duration: 1.0 }, 1.15);
  }

  /* ── Akt 1: Recede-Parallax (scroll-scrub, Desktop) ── */
  function heroParallax(hero) {
    var media  = hero.querySelector('.czsc-hero__media');
    var inner  = hero.querySelector('.czsc-hero__inner');
    var recede = hero.querySelector('.czsc-hero__recede');

    var tl = gsap.timeline({
      scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.5 }
    });
    if (media)  tl.to(media, { yPercent: 15, ease: 'none' }, 0);
    if (inner)  tl.to(inner, { yPercent: -10, ease: 'none' }, 0);
    if (recede) tl.to(recede, { opacity: 0.55, ease: 'none' }, 0);
  }

  /* ── Akt 2: Endzustand ohne Animation (Klasse, kein GSAP) ── */
  function showGrid(stage) {
    if (stage.dataset.assembled) return;
    stage.dataset.assembled = '1';
    stage.classList.add('grid-ready');
  }

  /* ── Akt 2: Grid assemble (maskiert + gestaffelt, Featured fuehrt) ── */
  function gridAssemble(stage) {
    if (stage.dataset.assembled) return;
    stage.dataset.assembled = '1';
    stage.classList.add('grid-ready');

    var cards = stage.querySelectorAll('.cz-showcase__card');
    if (!cards.length || !window.gsap) return; /* grid-ready hat sie schon sichtbar gemacht */

    var featured = stage.querySelector('.cz-showcase__card--featured');
    var ordered = [];
    if (featured) ordered.push(featured);
    cards.forEach(function (c) { if (c !== featured) ordered.push(c); });

    var imgs = [];
    ordered.forEach(function (c) {
      var i = c.querySelector('.cz-showcase__media img') || c.querySelector('.cz-showcase__ph');
      if (i) imgs.push(i);
    });

    /* MOBILE: gar kein JS-Reveal mehr.
       Hier lief vorher ein gsap.fromTo(opacity 0 -> 1). Das schreibt als
       ERSTES ein inline opacity:0 auf jede Kachel und raeumt es erst im
       onComplete wieder weg. Kommt der Tween nicht sauber durch, bleibt das
       Inline-Style stehen — und ein Inline-Style ist per CSS-Klasse nicht
       mehr einzufangen. Damit war auch .grid-ready (setzt opacity:1 per
       Klasse) wirkungslos: Inline schlaegt Klasse.
       Das passt exakt zum Fehlerbild — Kacheln im Hochformat unsichtbar,
       beim Drehen des Geraets (erzwungenes Relayout/Repaint) wieder da.
       Auf Mobile deckt jetzt allein CSS auf (siehe cz-heroshowcase.css,
       Mobile-Block). Es gibt keinen Zustand mehr, in dem JS die Kacheln
       verstecken kann. Desktop/Querformat bleibt unveraendert. */
    if (window.innerWidth <= 768) return;

    gsap.set(cards, { opacity: 1 });
    var tl = gsap.timeline({
      defaults: { ease: 'expo.out' },
      onComplete: function () {
        gsap.set(cards, { clearProps: 'clipPath,transform,opacity' });
        /* Bild-transform separat raeumen, sonst blockiert inline scale(1) den Hover-Zoom */
        if (imgs.length) gsap.set(imgs, { clearProps: 'transform' });
      }
    });
    tl.fromTo(ordered,
      { clipPath: 'inset(100% 0 0 0 round 8px)', y: 26 },
      { clipPath: 'inset(0% 0 0 0 round 8px)', y: 0, duration: 1.15, stagger: 0.09 }, 0);
    if (imgs.length) tl.fromTo(imgs,
      { scale: 1.12 },
      { scale: 1, duration: 1.5, stagger: 0.09, ease: 'power3.out' }, 0.05);
  }

  /* ── Arrows (horizontaler Scroll im Grid) ── */
  function bindInteractions(section) {
    var grid = section.querySelector('.cz-showcase__grid');
    var arrowL = section.querySelector('[data-sc-arrow="left"]');
    var arrowR = section.querySelector('[data-sc-arrow="right"]');
    if (!grid || !arrowL || !arrowR) return;

    function updateArrows() {
      var scrollLeft = grid.scrollLeft;
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      arrowL.classList.toggle('is-visible', scrollLeft > 10);
      arrowR.classList.toggle('is-visible', maxScroll > 10 && scrollLeft < maxScroll - 10);
    }
    function scrollByPage(dir) {
      var cols = window.innerWidth < 769 ? 2 : 4;
      var colW = grid.clientWidth / cols;
      var gap = parseFloat(getComputedStyle(grid).columnGap) || 6;
      grid.scrollBy({ left: dir * (colW + gap) * 2, behavior: 'smooth' });
    }
    arrowL.addEventListener('click', function () { scrollByPage(-1); });
    arrowR.addEventListener('click', function () { scrollByPage(1); });
    grid.addEventListener('scroll', updateArrows, { passive: true });
    setTimeout(updateArrows, 1200);
  }

  function initOne(section) {
    if (section.dataset.czInit) return;
    section.dataset.czInit = '1';

    var stage = section.querySelector('.cz-showcase__stage');
    var hero  = section.querySelector('.czsc-hero');
    if (!stage) return;

    bindInteractions(section);

    /* Ohne Hero (Live-Startseite) oder reduced-motion: sofort Endzustand,
       kein Warten auf GSAP. Ohne Hero gibt es nichts zu animieren — das
       Grid ist der erste Viewport. */
    if (!hero || prefersReduce()) {
      section.classList.add('hero-ready');
      showGrid(stage);
      return;
    }

    /* ── Ab hier: mit Hero ── */

    /* Mobile: Kacheln sind per CSS ohnehin sichtbar, gridAssemble() animiert
       dort nichts — Endzustand sofort. Desktop: liegt die Stage beim ersten
       Layout schon in der Reveal-Zone (kurzer Hero / hoher Viewport), steht
       sie ebenfalls sofort; der erste IO-Callback kommt nach dem ersten
       Layout, ohne erzwungenes Layout wie getBoundingClientRect(). Liegt sie
       darunter, uebernimmt run() (animiertes Assemble beim Hineinscrollen). */
    if (!mqMobile || mqMobile.matches) {
      showGrid(stage);
    } else if ('IntersectionObserver' in window) {
      var firstIo = new IntersectionObserver(function (entries) {
        firstIo.disconnect();
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { showGrid(stage); return; }
        }
      }, { rootMargin: ZONE_MARGIN });
      firstIo.observe(stage);
    }

    var done = false;
    function bluntReveal() {
      if (done) return;
      done = true;
      section.classList.add('hero-ready');
      showGrid(stage);
    }
    var fallback = setTimeout(bluntReveal, SHOW_AFTER_MS);

    function run() {
      if (!window.gsap) return false;
      done = true;
      clearTimeout(fallback);

      heroEntrance(section, hero);
      if (window.ScrollTrigger && window.innerWidth > 768) heroParallax(hero);

      /* Grid unterhalb der Reveal-Zone: animiert zusammensetzen, sobald es
         hineinscrollt (rootMargin = 'top 82%'). Ein zusaetzlicher
         ScrollTrigger dafuer war doppelt — der Observer allein reicht und
         haengt nicht an ScrollTrigger-Messungen (Hochformat-Bug: Stage-Hoehe
         haengt dort an den Bildern, ein vor dem Bild-Load gemessener Trigger
         feuerte nie). gridAssemble()/showGrid() sind ueber
         dataset.assembled gegen Doppelaufrufe geschuetzt. */
      if (!stage.dataset.assembled && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { io.disconnect(); gridAssemble(stage); return; }
          }
        }, { rootMargin: ZONE_MARGIN });
        io.observe(stage);
      }

      /* Wenn nach dem Laden immer noch nichts assembliert ist, hart
         aufdecken. Lieber ohne Animation sichtbar als animiert unsichtbar.
         (Ein eigenes ScrollTrigger.refresh() ist hier nicht noetig:
         ScrollTrigger vermisst sich bei window.load selbst neu.) */
      window.addEventListener('load', function () {
        setTimeout(function () { showGrid(stage); }, 400);
      });
      return true;
    }

    if (window.czGSAPReady) {
      czGSAPReady(function () { if (!run()) bluntReveal(); });
    } else if (!run()) {
      var start = Date.now();
      var poll = setInterval(function () {
        if (window.gsap) { clearInterval(poll); if (!done) run(); }
        else if (Date.now() - start > SHOW_AFTER_MS) { clearInterval(poll); }
      }, 100);
    }
  }

  ready(initAll);

  /* Theme editor: re-init bei Re-Render; alte ScrollTrigger dieser Section killen */
  document.addEventListener('shopify:section:load', function (e) {
    var sc = e.target.querySelector('.cz-showcase');
    if (!sc) return;
    if (window.ScrollTrigger) {
      ScrollTrigger.getAll().forEach(function (t) {
        if (t.trigger && e.target.contains(t.trigger)) t.kill();
      });
    }
    initOne(sc);
  });
})();
